export const CMD_SERVER_URL = process.env.REACT_APP_CMD_SERVER_URL;
export const NODE_RED_OFFLINE_URL = process.env.REACT_APP_NODE_RED_SERVER_OFFLINE_URL;
export const LOGIN_ONLINE_URL = process.env.REACT_APP_LOGIN_ONLINE_URL;